import { combineKeys, queryKey } from '../../../utils/queryUtils';
import { bookmarksKey } from '../me/bookmarks/keys';
import { subscribedProductsKey } from '../me/products/keys';
import { providersKey } from '../me/providers/keys';
import { FetchAssetOptions } from '../titles/api';
import { titleKey } from '../titles/keys';

export const recordingsKey = combineKeys(() => [queryKey('recordings')(), bookmarksKey()]);

export const recordingAssetKey = combineKeys((id: string, options?: FetchAssetOptions) => {
  return [
    'recording-asset',
    titleKey(id, options),
    providersKey(),
    recordingsKey(),
    subscribedProductsKey(),
    bookmarksKey(),
  ];
});
